// Issue severity mapped to Pill tones.

export const severityTone = {
  LOW: 'neutral',
  MEDIUM: 'warn',
  HIGH: 'bad',
  CRITICAL: 'bad',
}
